module.exports = __webpack_public_path__ + "img/copy.6b5b5890.svg";